var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowRibbon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 76",
    id: "vector",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M 4 4 L 0 4 L 4 0 L 4 4 Z",
    fill: "#c3b000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    d: "M 4.001 0 L 72.001 0 L 72.001 68 L 4.001 68 Z",
    fill: "#ffe600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    d: "M 38 76 L 4 66 L 72 66 Z",
    fill: "#ffe600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowRibbon);
export default __webpack_public_path__ + "static/media/yellow-ribbon.d38bd1db39ea858c52420c44474acede.svg";
export { ForwardRef as ReactComponent };